import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import MonitoringCenterAllRequests from './MonitoringCenterAllRequests';

loadDOMComponent({
	selector: 'react-monitoring-center-all-requests',
	callback: ({ container, context, props }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<MonitoringCenterAllRequests />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
